import React from "react";
import { useSession } from "../utils/Session";
import { Button, Divider, Space } from 'antd';
import Html from "../utils/Html";

function AccountComplete() {

        const [session] = useSession();
        const { email_address, first_name, last_name } = session.user;
        const { phone, name, email } = window.sitesettings.store_info;
      

        return (
                <div>
                        <h2>New account created for {first_name} {last_name}</h2>
                        <div aria-hidden><Divider dashed style={{"margin" : "15px 0px"}} /></div>
                        <p>Thank you! You can now use this account to login, however, it will not be formally linked or operational with any companies or services until our staff or the company you indicated you are working for has authorized your relationship with them. We may contact you by email or phone once we have reviewed your request.</p>
                        <p>Please don't hesitate to contact us by phone at 250-763-4415 for expedited service, from Monday to Friday, 8am - 4pm PST.</p>
                        <p>We hope you will be able to make good use of the services and connections Bookmanager provides!</p>
                        
                </div>
        );

}

export default AccountComplete; 